(function() {
  const header_operlay = document.querySelector("[data-banner-header-overlay]");
  if(header_operlay){
    document.body.classList.add('header-transparent');
    document.querySelector("header").classList.add('header--transparent');
  } 


   const navigation = document.querySelectorAll("[data-faq_toggal]") || null;
        if(navigation){
            navigation.forEach(function(anchor) {
              anchor.addEventListener("click", function(event) {
                event.preventDefault(); // Prevent default anchor behavior
        
                // Remove 'active' class from all anchors
                navigation.forEach(function(nav) {
                  nav.classList.remove("active");
                });
        
                // Add 'active' class to the clicked anchor
                this.classList.add("active");
        
                // Smooth scroll to the target
                const navigation_all = this.closest('[id^="shopify-section-template"]').querySelectorAll("[data-tab_content]");
               const main_conten = document.querySelector(this.hash) || null;
               if(main_conten){
               
                navigation_all.forEach(function(content) {
                  content.classList.remove("show_content");
                });
                 main_conten.classList.add("show_content");
               }
              });
            });
          }
  
  
})();

 // PASSWORD SHOW AND HIDE start

class ShowPassword extends HTMLElement {
  constructor() {
    super();                  
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  } 

  show_password(event) {
    event.preventDefault();
    this.closest('.passowrd-eye-show').querySelector('input').setAttribute('type', this.closest('.passowrd-eye-show').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

customElements.define('show-password', ShowPassword);
// PASSWORD SHOW AND HIDE END

// RED MORE START

class ReadMoreMain extends HTMLElement {
  constructor() {
    super();
    this.facetLink = this.querySelector('[data-redmore-btn]') || null;
    this.content_main_content = this.querySelector('[data-main-content]') || null;
    if(!this.facetLink & !this.content_main_content) return;
    this.maie_hight = this.content_main_content.offsetHeight || 100;
     this.scroll_hight = this.content_main_content.scrollHeight || 100;
    this.facetLink.setAttribute('role', 'button');
    this.facetLink.addEventListener('click', this.show_full_content.bind(this));
    this.check_height();
  }

  show_full_content(event) {
    event.preventDefault();
    this.classList.toggle('show-full-content');
    this.classList.contains('show-full-content') ? (this.content_main_content.style.height = '100%' , event.target.querySelector('[data-btn-text-toggal]').innerHTML =  event.target.getAttribute('data-red-less-text')):(this.content_main_content.style.height = `${this.maie_hight}px` , event.target.querySelector('[data-btn-text-toggal]').innerHTML =  event.target.getAttribute('data-red-more-text'));
  }
    check_height(){
     if(this.maie_hight >=  this.scroll_hight) this.facetLink.hidden = true; 
    // this.content_main_content.style.height = this.maie_hight;
  }
}
customElements.define('read-more-main', ReadMoreMain);




class ReadMoreMainText extends HTMLElement {
  constructor() {
    super();
    this.facetLink = this.querySelector('[data-redmore-btn]') || null;
    this.content_main_content = this.querySelector('[data-main-content]') || null;
    if(!this.facetLink & !this.content_main_content) return;
     this.text_count = 150;
    if(!this.content_main_content.textContent.length > this.text_count) return;
    this.facetLink.setAttribute('role', 'button');
    this.facetLink.addEventListener('click', this.show_full_content.bind(this));
    this.check_height();
  }

  show_full_content(event) {
    event.preventDefault();
    this.classList.toggle('show-full-content');
    this.classList.contains('show-full-content') ? (event.target.querySelector('[data-btn-text-toggal]').innerHTML =  event.target.getAttribute('data-red-less-text')):(event.target.querySelector('[data-btn-text-toggal]').innerHTML =  event.target.getAttribute('data-red-more-text'));
  }
   check_height(){
              var strtoadd = this.content_main_content.textContent.substring(0, this.text_count) +"<span class='second-section'>" + this.content_main_content.textContent.substring(this.text_count, this.content_main_content.textContent.length) + "</span>";
               this.content_main_content.innerHTML = strtoadd;
               this.content_main_content.appendChild(this.facetLink);
          
  }
}
customElements.define('read-more-main-text', ReadMoreMainText);

// $(document).ready(function(){
//      function AddReadMore() {
//       //This limit you can set after how much characters you want to show Read More.
//       var carLmt = 300;
//       // Text to show when text is collapsed
//       var readMoreTxt = " ...read more";
//       // Text to show when text is expanded
//       var readLessTxt = " read less";


//       //Traverse all selectors with this class and manupulate HTML part to show Read More
//       $(".add-read-more").each(function () {
//          if ($(this).find(".first-section").length)
//             return;

//          var allstr = $(this).text();
//          if (allstr.length > carLmt) {
//             var firstSet = allstr.substring(0, carLmt);
//             var secdHalf = allstr.substring(carLmt, allstr.length);
//             var strtoadd = firstSet + "<span class='second-section'>" + secdHalf + "</span><span class='read-more'  title='Click to Show More'>" + readMoreTxt + "</span><span class='read-less' title='Click to Show Less'>" + readLessTxt + "</span>";
//             $(this).html(strtoadd);
//          }
//       });

//       //Read More and Read Less Click Event binding
//       $(document).on("click", ".read-more,.read-less", function () {
//          $(this).closest(".add-read-more").toggleClass("show-less-content show-more-content");
//       });
//    }

//    AddReadMore();
// });










// drawercloss code


class DrawerClose extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const main_content = this.closest('[id^="shopify-section-sections"]') || null;
    if(!main_content) return
    const main_button =  main_content.querySelector('[data-js-menu-button]') || null;
    if(main_button) main_button.click();
  }
}
customElements.define('drawer-close', DrawerClose);